import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

const propTypes = exact({
  message: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
});

const defaultProps = {
  message: null,
};

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: 'Please try again', stack: '' };
  }

  componentDidCatch({ message, stack }, { componentStack }) {
    this.setState({ hasError: true, message, stack, componentStack });
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.message !== null) return this.props.message;

    return (
      <article className="ErrorBoundary">
        <h2 className="ErrorBoundary_title">Something went wrong</h2>
        {this.state.message && <div className="ErrorBoundary_message">{this.state.message}</div>}
        {this.state.stack && <small className="ErrorBoundary_code">{this.state.stack}</small>}
      </article>
    );
  }
}

ErrorBoundary.propTypes = propTypes;
ErrorBoundary.defaultProps = defaultProps;
export default ErrorBoundary;

export function withErrorBoundary(WrappedComponent) {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  // Creating the inner component. The calculated Props type here is the where the magic happens.
  const WithErrorBoundary = (props) => (
    <ErrorBoundary>
      <WrappedComponent {...props} />
    </ErrorBoundary>
  );

  WithErrorBoundary.displayName = `withErrorBoundary(${displayName})`;

  return WithErrorBoundary;
}
